<template>
	<div class="go-in">
		<banner img="../assets/img/bgtop.jpg" title="走进荣展" />
		<div class="content">
			<el-row :gutter="20" style="background-color: whitesmoke" type="flex" justify="space-between"
				align="stretch">
				<el-col :span='12'>
					<div class="left-contain" style="margin-bottom: 20px;">
						<h1 style="color: deepskyblue; font-size: 50px; text-align: center; margin-bottom: 10px;">联系我们
						</h1>
						<p style="font-size: 25px; text-indent: 2em; color: black;;">如果您对我们的产品感兴趣并想给出答案，
							请在此处留下您的反馈和联系信息，以方便我们的后续沟通。</p>
					</div>
					<div class="left-contain">
						<h1 style="color: black; font-size: 40px; text-align: center; margin-bottom: 10px;">昆山荣展精密模具有限公司
						</h1>
						<div class='info-item'><i class="el-icon-message icon" /> <span
								style="font-weight: 600">邮件：</span><span> rongzhan@rzmj.com</span></div>
						<div class='info-item'><i class="el-icon-message icon" /> <span
								style="font-weight: 600">电话：</span><span> 0512-57784468</span></div>
						<div class='info-item'><i class="el-icon-message icon" /> <span
								style="font-weight: 600">传真：</span><span> 0512-57784458</span></div>
						<div class='info-item'><i class="el-icon-message icon" /> <span
								style="font-weight: 600">地址：</span><span> 昆山市周市镇金茂路1288号11号厂房</span></div>
					</div>
				</el-col>
				<el-col :span='12' class="centered-col">
					<div class="right-contain">
						<el-row :gutter='20' class="message" type="flex" justify="space-between" align="stretch">
							<el-col :span='12'>
								<div style="margin-bottom: 10px;">
									<span style="color: red;">*</span>
									<span style="color: black; font-weight: 500;">姓名</span>
								</div>
								<el-input placeholder='您的姓名' style="margin-bottom: 10px;"></el-input>
								<div style="margin-bottom: 10px;">
									<span style="color: red;">*</span>
									<span style="color: black; font-weight: 500;">邮箱</span>
								</div>
								<el-input placeholder='您的邮箱' style="margin-bottom: 10px;"></el-input>
								<div style="margin-bottom: 10px;">
									<!-- 									<span style="color: red;">*</span> -->
									<span style="color: black; font-weight: 500;">电话</span>
								</div>
								<el-input placeholder='您的电话' style="margin-bottom: 10px;"></el-input>
								<!-- 								<div>
									<span style="color: red;">*</span>
									<span style="color: black; font-weight: 500;">姓名</span>
								</div>
								<el-input placeholder='您的姓名'></el-input> -->
								<el-button type="primary" style="margin-top: 10px;"> 提交</el-button>
							</el-col>
							<el-col :span='12'>
								<div style="margin-bottom: 10px;">
									<span style="color: black; font-weight: 500;">留言</span>
								</div>
								<el-input type="textarea" placeholder='留言...' rows='9'></el-input>
							</el-col>
						</el-row>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-left: -10px; margin-right: -10px; background-color: whitesmoke;">
				<el-col :span='24'>
					<div style="padding: 50px;">
						<div id="mapContain" class="map"/>
					</div>
				</el-col>
			</el-row>
			
		</div>
	</div>
</template>
<script>
	import Banner from "../components/Banner";
	import {
		BaiduMap
	} from "vue-baidu-map";
	// import BMap from 'bmap'
	export default {
		components: {
			Banner,
			BaiduMap
		},
		data() {
			return {
				center: {
					lng: 116.404,
					lat: 39.915
				},
				zoom: 20,
			};
		},
		mounted() {
			var map = new BMapGL.Map("mapContain");          // 创建地图实例 
			var point = new BMapGL.Point(120.95749,31.483721);  // 创建点坐标 
			map.centerAndZoom(point, 19);                 // 初始化地图，设置中心点坐标和地图级别
			map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
			var marker = new BMapGL.Marker(point);        // 创建标注   
			map.addOverlay(marker);                     // 将标注添加到地图中
			
			// const map = new BMap.Map('mapContain') // 创建Map实例
			// const point = new BMap.Point(116.404, 39.915) // 创建点坐标
			// map.centerAndZoom(point, 15) // 初始化地图,设置中心点坐标和地图级别
		}
	};
</script>

<style lang="scss" scoped>
	.go-in {
		width: 100%;
		height: 100%;
		background-color: #14679f;

		.content {
			margin-left: 100px;
			margin-right: 100px;
			height: 100%;
		}

		.left-contain {
			justify-content: center;
			/* 垂直居中 */
			align-items: center;
			/* 水平居中 */
			padding: 10px;

			.info-item {
				font-size: 25px;
				color: black;
				;
				margin-bottom: 20px;

				.icon {
					margin-right: 10px;
				}

				.span {
					margin-right: 10px;
				}
			}
		}

		.right-contain {
			height: 100%;
			margin: 30px;
		}

		.message {
			margin: 30px;
			padding: 30px;
			border: 1px;
			background-color: white;
			border: 2px solid gray;
			/* 设置边框宽度、样式和颜色 */
			border-radius: 15px;
			/* 设置圆角 */
		}

		.centered-col {
			display: flex;
			justify-content: center;
			/* 水平居中 */
			align-items: center;
			/* 垂直居中 */
			// background-color: #f0f0f0;
			height: 100%;
		}
		.map{
			weight: 500px;
			height: 500px;
		}
	}
</style>
